import { useEffect, useState } from "react";
import { Get } from "../helpers/AxiosHelper";
import { Block, BlockHeader, BlockTitle, Button, Card, Link, List, ListItem, Navbar, Page, Panel, Range } from "konsta/react";
import TabBar from "../components/TabBar";
import { useAppContext } from "../context/AppContext";
import { formatUSD } from "../utils";
import { FaCartPlus, FaFilter } from "react-icons/fa6";
import { Product } from "../models/Models";
import { useNavigate } from "react-router-dom";

const defaultConfig = {
  changed: false,
  reset: false,
  price: {
    min: 0,
    max: 0
  },
  avgProfitPerDay: {
    min: 0,
    max: 0
  },
}

const BrowserNotSupportedPage = () => {

    return (
      <Page>
        Browser not supported
      </Page>
    );
  };
  
  export default BrowserNotSupportedPage;
  